import React from 'react';
import { ErrorMessage } from 'js/components/common/ErrorMessage';

import style from './UnregisteredPortlet.scss';

export const UnregisteredPortlet = ({ config: { portletType = 'unknown' } = {} }) =>
    <ErrorMessage className={style.error} error={`Error: Unregistered portlet "${portletType}"`} />;
